import React from 'react'
import { Icon } from './Icon'
export const IconPencil = (props) => (
    <Icon {...props}>
        <polygon points="14 2 18 6 7 17 3 17 3 13 14 2"></polygon><line x1="3" y1="22" x2="21" y2="22"></line>
    </Icon>
)